module.exports = __webpack_public_path__ + "img/Logo_eFC.9819ef56.png";